<template>
    <div class="recommended-posts-item row g-0 flex-nowrap">
        <div class="col-auto d-flex flex-column justify-content-center">
            <a :href="post.permalink" class="d-inline-block">
                <lazy-image
                    class="thumbnail"
                    :src="post.thumbnail"
                    width="100"
                    height="124"
                    :cover="true"
                ></lazy-image>
            </a>
        </div>
        <div class="col px-3 d-flex flex-column justify-content-center">
            <div class="text-center text-uppercase">
                <a :href="post.categoryPermalink" class="category font-family-1 fw-400">{{ post.categoryName }}</a>
            </div>
            <div class="text-center">
                <a :href="post.permalink" class="title font-family-2 fw-700">{{ post.title }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import LazyImage from "./LazyImage";
export default {
    name: "RecommendedPostsItem",
    components: { LazyImage },
    props: {
        post: {
            type: Object,
            default: {}
        }
    }
}
</script>

<style lang="scss" scoped>
    .recommended-posts-item {

        padding: 16px 0;

        @media screen and (max-width: 993px) {
            border-top: 1px solid #E8E8E8;
            padding: 0;
        }

    }

    .thumbnail {
        background: #E8E8E8;

        &:hover {
            opacity: 0.8;
        }
    }

    .category {
        display: inline-block;
        font-size: 10px;
        line-height: 20px;
        color: black;
        text-decoration: none;
        letter-spacing: 0.1em;

        &:hover {
            text-decoration: underline;
        }
    }

    .title {
        display: inline-block;
        font-size: 20px;
        line-height: 25px;
        margin-top: 8px;
        color: black;
        text-decoration: none;
        max-width: 300px;
        max-height: 2.5em;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
            text-decoration: underline;
        }
    }
</style>